import React, {useEffect, useState} from 'react'
import {
    acceptCreatorsCampaignContent,
    denyCampaignCreator,
    getCampaignByName,
    getCampaignCreators, getCreatorsCampaignContent, getCreatorsPaymentStatus,
    updateCampaignCreator, updateCampaignCreatorStatus
} from "../services/CampaignService";
import {useNavigate, useParams} from "react-router-dom";
import "../stylesheets/Campaign.css";


import Modal from "react-modal";
import {
    enableCreatorMessaging,
    getCreatorsAesthetics
} from "../services/CreatorService";
import Header from './Header';
import CampaignPreview from './CampaignPreview';
import {StyleSheet, View, Image, Text, TextInput, TouchableOpacity, ScrollView, Pressable} from 'react-native-web';
import Button from './Button';

import toast, {Toaster} from "react-hot-toast";
import SendbirdChat from "@sendbird/chat";
import {GroupChannelFilter, GroupChannelListOrder, GroupChannelModule} from "@sendbird/chat/groupChannel";
import {GroupChannel} from "@sendbird/uikit-react/GroupChannel";
import SendbirdProvider from "@sendbird/uikit-react/SendbirdProvider";
import upArrowIcon from "../icons/up-arrow-icon.png";
import CustomCheckbox from './CustomCheckbox';
import ContentModal from './ContentModal';
import CreatorModal from './CreatorModal';
import CreatorPreview from './CreatorPreview';

const Campaign = () => {

    const [campaign, setCampaign] = useState({})
    const [selectedCreator, setSelectedCreator] = useState({})
    const [creatorsAesthetics, setCreatorsAesthetics] = useState([])
    const [selectedAesthetic, setSelectedAesthetic] = useState(null)
    const [inviteModal, setInviteModal] = useState(false)
    const [updateType, setUpdateType] = useState('')
    const [creatorModal, setCreatorModal] = useState(false)
    const [messageModal, setMessageModal] = useState(false)
    const [denyApplicantModal, setDenyApplicantModal] = useState(false)
    const [showDeniedCreators, setShowDeniedCreators] = useState(false)
    const [contentModal, setContentModal] = useState(false)
    const [inviteNotes, setInviteNotes] = useState("")
    const [channelUrl, setChannelUrl] = useState("")
    const [businessId, setBusinessId] = useState("")
    const [campaignCreators, setCampaignCreators] = useState({})
    const [creatorsUploads, setCreatorsUploads] = useState({})
    const [activeCreators, setActiveCreators] = useState([]);
    const [selectedStage, setSelectedStage] = useState("Active")
    const [confirmPhotos, setConfirmPhotos] = useState(true)
    const [creatorPaymentsAllowed, setCreatorPaymentsAllowed] = useState(false)
    const [showTransferError, setShowTransferError] = useState(false)
    const [expandedCreatorReviewId, setExpandedCreatorReviewId] = useState(null);
    const [isInvitingAll, setIsInvitingAll] = useState(false);
    const [inviteAllChecked, setInviteAllChecked] = useState(false);
    let { campaignSlug } = useParams();
    const navigate = useNavigate();

    const myColorSet = {
        '--sendbird-light-primary-500': '#396DE0',
        '--sendbird-light-primary-400': '#396DE0',
        '--sendbird-light-primary-300': '#396DE0',
        '--sendbird-light-primary-200': '#396DE0',
        '--sendbird-light-primary-100': '#396DE0',
    };

    const sb = SendbirdChat.init({
        appId: '960C8598-DEDE-43E0-89FA-45442999623C',
        modules: [
            new GroupChannelModule(),
        ],
    });


    function afterOpenModal() {

    }

    function closeModal() {
        setInviteModal(false);
        setCreatorModal(false);
        setMessageModal(false);
        setDenyApplicantModal(false);
        setContentModal(false);
        setConfirmPhotos(true);
        setShowTransferError(false);
        setCreatorPaymentsAllowed(false);
        setIsInvitingAll(false);
        setInviteAllChecked(false);
        setSelectedAesthetic(null);
        setSelectedCreator({});
        setCreatorsAesthetics([]);
    }

    function openMessageModal(channelUrlInput) {
        setChannelUrl(channelUrlInput);
        setMessageModal(true);
    }

    function openDenyApplicantModal(creator) {
        setSelectedCreator(creator);
        setDenyApplicantModal(true);
    }

    function startMessaging(user) {
        if (user.channel && user.channel._url) {
            setChannelUrl(user.channel._url);
            setMessageModal(true);
        } else {
            enableCreatorMessaging(user.id)
                .then(resp => {
                    const params = {
                        invitedUserIds: [user.id],
                        name: user.first_name + " " + user.last_name + " and " + campaign.name,
                        operatorUserIds: [campaign.businessId],
                        channelUrl: campaign.id + "_" + user.id,
                        isDistinct: false,
                        customType: campaign.id,
                    };
                    sb.groupChannel.createChannel(params)
                        .then(sbResp => {
                            setChannelUrl(campaign.id + "_" + user.id);
                            setMessageModal(true);
                        })
                        .catch(err => {
                            console.log(err);
                        })
                })
        }
    }

    function openUpdateModal(creator, updateType) {
        setSelectedCreator(creator);
        setUpdateType(updateType);
        setInviteNotes("");
        setInviteModal(true);
    }

    function openCreatorModal(creator, aesthetic) {
        setSelectedCreator(creator);
        setSelectedAesthetic(aesthetic || null);
        setCreatorModal(true);

        getCreatorsAesthetics(creator.id)
            .then(resp => {
                if (resp.status === 200 && resp.data) {
                    setCreatorsAesthetics(resp.data);
                }
            })
    }

    function triggerInviteCreator() {
        if (isInvitingAll) return; // Prevent multiple executions

        // Check if we should invite all or just the selected creator
        if (inviteAllChecked && selectedStage === "Shortlisted" && campaignCreators.shortlisted && campaignCreators.shortlisted.length > 1) {
            // Invite all shortlisted creators
            setIsInvitingAll(true);

            const invitePromises = campaignCreators.shortlisted.map(creator => {
                const req = {
                    creatorId: creator.id,
                    stage: updateType === "Invite" ? "Invite" : "Accept",
                    notes: inviteNotes
                };
                return updateCampaignCreator(campaign.id, req);
            });

            Promise.all(invitePromises)
                .then(responses => {
                    const successCount = responses.filter(resp => resp.status === 200).length;
                    const totalCount = campaignCreators.shortlisted.length;

                    if (successCount === totalCount) {
                        toast.success(`Successfully invited all ${totalCount} creators`);
                    } else {
                        toast.error(`Invited ${successCount} out of ${totalCount} creators`);
                    }

                    closeModal();
                    getCampaignCreators(campaign.id)
                        .then(creatorResp => {
                            if (creatorResp.status === 200 && creatorResp.data) {
                                setCampaignCreators(creatorResp.data);
                            }
                        })
                })
                .catch(err => {
                    console.error('Error inviting creators:', err);
                    toast.error('Failed to invite creators. Please try again.');
                    setIsInvitingAll(false);
                });
        } else {
            // Invite only the selected creator (original logic)
            let req = {};
            req.creatorId = selectedCreator.id;
            req.stage = updateType;
            req.notes = inviteNotes;
            updateCampaignCreator(campaign.id, req)
                .then(resp => {
                    closeModal();
                    getCampaignCreators(campaign.id)
                        .then(creatorResp => {
                            if (creatorResp.status === 200 && creatorResp.data) {
                                setCampaignCreators(creatorResp.data);
                            }
                        })
                })
        }
    }

    function acceptContent() {
        acceptCreatorsCampaignContent(campaign.id, selectedCreator.id)
            .then(resp => {
                if (resp.status === 200) {
                    closeModal();
                    window.location.reload();
                }
            })
            .catch(err => {
                if (err && err.response && err.response.data && err.response.data.error && err.response.data.error.message
                    && err.response.data.error.message === "Insufficient Funds") {
                    setShowTransferError(true);
                }
            })
    }

    function triggerCampaignDeny() {
        denyCampaignCreator(campaign.id, selectedCreator.id)
            .then(() => {
                closeModal();
                getCampaignCreators(campaign.id)
                    .then(creatorResp => {
                        if (creatorResp.status === 200 && creatorResp.data) {
                            setCampaignCreators(creatorResp.data);
                        }
                    })
            })
    }



    function copyEmail(email) {
        navigator.clipboard.writeText(email);
        toast.success('Email copied');
    }
    function handleUpdateDropdown(event, creatorId) {
        let req = {};
        req.status = event.target.value;
        updateCampaignCreatorStatus(campaign.id, creatorId, req);
        setActiveCreators(activeCreators.map(creator => {
            if (creator.id === creatorId) {
                return {...creator, status: event.target.value}
            } else {
                return creator
            }
        }))
    }

    function openContentModal(creator) {
        getCreatorsCampaignContent(campaign.id, creator.id)
            .then(resp => {
                if (resp.status === 200 && resp.data) {
                    setSelectedCreator(creator);
                    setContentModal(true);
                    setCreatorsUploads(resp.data);
                }
            })
        if (campaign.paymentCompensation && campaign.defaultPayment > 0) {
            getCreatorsPaymentStatus(creator.id)
                .then(resp => {
                    if (resp.status === 200 && resp.data && resp.data.paymentsEnabled) {
                        setCreatorPaymentsAllowed(true);
                    }
                })
        }
    }



    useEffect(()=>{
        getCampaignByName(campaignSlug)
            .then(resp => {
                if (resp.status === 200 && resp.data) {
                    setCampaign(resp.data);
                    sb.connect(resp.data.businessId);
                    setBusinessId(resp.data.businessId);
                    getCampaignCreators(resp.data.id)
                        .then(creatorResp => {
                            if (creatorResp.status === 200 && creatorResp.data) {
                                setCampaignCreators(creatorResp.data);
                                console.log("hi")
                                if (creatorResp.data && (creatorResp.data.active && creatorResp.data.active.length > 0 || creatorResp.data.complete && creatorResp.data.complete.length)) {
                                    const groupChannelFilter = new GroupChannelFilter();
                                    groupChannelFilter.includeEmpty = true; // Optional.
                                    groupChannelFilter.customTypesFilter = [resp.data.id];
                                    // groupChannelFilter.publicChannelFilter  = PublicChannelFilter.PUBLIC; // Retrieve public group channels. Optional.
                                    // groupChannelFilter.superChannelFilter = SuperChannelFilter.SUPER; // Retrieve Supergroup channels. Optional.

                                    const groupChannelCollection = sb.groupChannel.createGroupChannelCollection({
                                        filter: groupChannelFilter,
                                        order: GroupChannelListOrder.LATEST_LAST_MESSAGE,
                                        // ...
                                    });
                                    let channelMap = {};
                                    if (groupChannelCollection.hasMore) {
                                        groupChannelCollection.loadMore()
                                            .then(channelResp => {
                                                channelResp.forEach((channel) => {
                                                    if (channel._url) {
                                                        const channelParams = channel._url.split("_");
                                                        if (channelParams.length > 1) {
                                                            channelMap[channelParams[1]] = channel;
                                                        }
                                                    }
                                                });
                                                creatorResp.data.active.forEach(creator => {
                                                    if (creator.id in channelMap) {
                                                        creator.channel = channelMap[creator.id]
                                                        if (channelMap[creator.id] && channelMap[creator.id].lastMessage && channelMap[creator.id].lastMessage.message) {
                                                            creator.lastMessage = channelMap[creator.id].lastMessage.message;
                                                        }
                                                    }
                                                });
                                                creatorResp.data.complete.forEach(creator => {
                                                    if (creator.id in channelMap) {
                                                        creator.channel = channelMap[creator.id]
                                                        if (channelMap[creator.id] && channelMap[creator.id].lastMessage && channelMap[creator.id].lastMessage.message) {
                                                            creator.lastMessage = channelMap[creator.id].lastMessage.message;
                                                        }
                                                    }
                                                });
                                                setActiveCreators(creatorResp.data.active);
                                            });
                                    }
                                }
                            }
                        })
                }
            })

    }, []);



    function CreatorStatusSelection(stage) {
        return (
            <TouchableOpacity style={selectedStage === stage ? styles.creatorStatusSelectionHighlighted : styles.creatorStatusSelection} onPress={event => setSelectedStage(stage)}>
                <Text style={styles.boldText}>{stage}</Text>
                <Text style={styles.text}>{campaignCreators[stage.toLowerCase()] ? campaignCreators[stage.toLowerCase()].length : 0}</Text>
            </TouchableOpacity>
        );
    }
    return(
        <div>
            <Header title="Campaign" />
            <div className={"container-label-div"}/>
            <CampaignPreview campaign={campaign} campaignOpened={true} />
            <View style={styles.creatorStatusContainer}>
                {CreatorStatusSelection("Complete")}
                {CreatorStatusSelection("Active")}
                {CreatorStatusSelection("Applied")}
                {CreatorStatusSelection("Invited")}
                {CreatorStatusSelection("Shortlisted")}
            </View>
            <View>
                {selectedStage === "Active" && activeCreators && activeCreators.map(creator => (
                    <CreatorPreview
                        key={creator.id}
                        creator={creator}
                        variant="active"
                        onCreatorPress={openCreatorModal}
                        onAestheticPress={openCreatorModal}
                        onMessagePress={(channelUrl) => {
                            if (typeof channelUrl === 'string') {
                                openMessageModal(channelUrl);
                            } else {
                                startMessaging(channelUrl);
                            }
                        }}
                        onEmailCopy={copyEmail}
                        onContentModalOpen={openContentModal}
                        onUpdateDropdown={handleUpdateDropdown}
                        expandedCreatorReviewId={expandedCreatorReviewId}
                        campaign={campaign}
                        businessId={businessId}
                    />
                ))}
                {selectedStage === "Applied" && campaignCreators.applied && (
                    <View>
                        {campaignCreators.applied.map(creator => (
                            <CreatorPreview
                                key={creator.id}
                                creator={creator}
                                variant="applied"
                                onCreatorPress={openCreatorModal}
                                onAestheticPress={openCreatorModal}
                                onUpdateModal={openUpdateModal}
                                onDenyApplicant={openDenyApplicantModal}
                                expandedCreatorReviewId={expandedCreatorReviewId}
                                campaign={campaign}
                                businessId={businessId}
                            />
                        ))}
                        {campaignCreators.appliedDenied && (
                            <View style={styles.archivedView}>
                                <Pressable style={{flexDirection: "row", justifyContent: "space-between",}} onPress={() => setShowDeniedCreators(!showDeniedCreators)}>
                                    <Text style={styles.redText}>Denied Creators ({campaignCreators.appliedDenied.length})</Text>
                                    <Image source={upArrowIcon} style={showDeniedCreators ? styles.arrowIcon : styles.rotatedArrowIcon} />
                                </Pressable>
                            </View>
                        )}
                        {showDeniedCreators && campaignCreators.appliedDenied.map(creator => (
                            <CreatorPreview
                                key={creator.id}
                                creator={creator}
                                variant="applied"
                                onCreatorPress={openCreatorModal}
                                onAestheticPress={openCreatorModal}
                                onUpdateModal={openUpdateModal}
                                onDenyApplicant={openDenyApplicantModal}
                                expandedCreatorReviewId={expandedCreatorReviewId}
                                campaign={campaign}
                                businessId={businessId}
                            />
                        ))}
                    </View>
                )}
                {selectedStage === "Invited" && campaignCreators.invited && campaignCreators.invited.map(creator => (
                    <CreatorPreview
                        key={creator.id}
                        creator={creator}
                        variant="invited"
                        onCreatorPress={openCreatorModal}
                        onAestheticPress={openCreatorModal}
                        expandedCreatorReviewId={expandedCreatorReviewId}
                        campaign={campaign}
                        businessId={businessId}
                    />
                ))}
                {selectedStage === "Shortlisted" && campaignCreators.shortlisted && campaignCreators.shortlisted.map(creator => (
                    <CreatorPreview
                        key={creator.id}
                        creator={creator}
                        variant="shortlisted"
                        onCreatorPress={openCreatorModal}
                        onAestheticPress={openCreatorModal}
                        onUpdateModal={openUpdateModal}
                        expandedCreatorReviewId={expandedCreatorReviewId}
                        campaign={campaign}
                        businessId={businessId}
                    />
                ))}
                {selectedStage === "Complete" && campaignCreators.complete && campaignCreators.complete.map(creator => (
                    <CreatorPreview
                        key={creator.id}
                        creator={creator}
                        variant="complete"
                        onCreatorPress={openCreatorModal}
                        onAestheticPress={openCreatorModal}
                        onMessagePress={(channelUrl) => {
                            if (typeof channelUrl === 'string') {
                                openMessageModal(channelUrl);
                            } else {
                                startMessaging(channelUrl);
                            }
                        }}
                        onEmailCopy={copyEmail}
                        onContentModalOpen={openContentModal}
                        onReviewToggle={setExpandedCreatorReviewId}
                        expandedCreatorReviewId={expandedCreatorReviewId}
                        campaign={campaign}
                        businessId={businessId}
                    />
                ))}
            </View>
            <Modal
                isOpen={inviteModal}
                onAfterOpen={afterOpenModal}
                onRequestClose={closeModal}
                className={"invite-modal"}
                style={styles.modal}
            >
                <View style={{alignItems: 'center', backgroundColor: 'white', borderRadius: 10, padding: 20}}>
                    {updateType === "Invite" && inviteAllChecked && (
                        <Text style={[styles.sectionText, {margin: 10}]}>Invite all shortlisted Creators to your campaign ({campaignCreators.shortlisted ? campaignCreators.shortlisted.length : 0})</Text>
                    )}
                    {updateType !== "Remove" && !inviteAllChecked && (
                        <Text style={[styles.sectionText, {margin: 10}]}>{updateType} {selectedCreator.username} to your campaign</Text>
                    )}
                    {updateType === "Remove" && (
                        <Text style={[styles.sectionText, {margin: 10}]}>{updateType} {selectedCreator.username} from your campaign</Text>
                    )}
                    <View style={{width: '70%'}}>
                        {updateType !== "Remove" && (
                            <TextInput
                                multiline
                                rows={3}
                                maxLength={200}
                                style={styles.greyInput}
                                value={inviteNotes}
                                onChange={event => setInviteNotes(event.target.value)}
                                placeholder="Message to Creator"
                                placeholderTextColor="#737373"
                            />
                        )}
                        {updateType === "Invite" && selectedStage === "Shortlisted" && campaignCreators.shortlisted && campaignCreators.shortlisted.length > 1 && (
                            <View style={styles.checkboxContainer}>
                                <CustomCheckbox
                                    value={inviteAllChecked}
                                    onValueChange={setInviteAllChecked}
                                />
                                <Text style={styles.checkboxLabel}>
                                    Invite all Shortlisted Creators ({campaignCreators.shortlisted.length})
                                </Text>
                            </View>
                        )}
                        <View style={{flexDirection: 'row', alignItems: 'center', justifyContent: 'center', width: '100%'}}>
                            <Button text="Cancel" onPress={closeModal} variant='secondary' style={{marginRight: 10, marginTop: 10}} />
                            <Button
                                text={isInvitingAll ? "Inviting..." : updateType}
                                onPress={triggerInviteCreator}
                                style={{marginTop: 10}}
                                disabled={isInvitingAll}
                                variant={updateType === "Remove" ? 'warning' : 'primary'}
                            />
                        </View>
                    </View>
                </View>
            </Modal>
            <CreatorModal
                isOpen={creatorModal}
                onClose={closeModal}
                selectedCreator={selectedCreator}
                creatorsAesthetics={creatorsAesthetics}
                afterOpenModal={afterOpenModal}
                initialAesthetic={selectedAesthetic}
            />
            <Modal
                isOpen={messageModal}
                onAfterOpen={afterOpenModal}
                onRequestClose={closeModal}
                className={"invite-modal"}
                style={styles.modal}
            >
                <View style={styles.messageView}>
                    <SendbirdProvider
                        appId={'960C8598-DEDE-43E0-89FA-45442999623C'}
                        userId={businessId}
                        colorSet={myColorSet}
                    >
                        {/* GroupChannel should be always wrapped inside SendbirdProvider */}
                        <GroupChannel channelUrl={channelUrl} />
                    </SendbirdProvider>
                </View>
            </Modal>
                        <ContentModal
                isOpen={contentModal}
                onClose={closeModal}
                selectedCreator={selectedCreator}
                creatorsUploads={creatorsUploads}
                campaign={campaign}
                creatorPaymentsAllowed={creatorPaymentsAllowed}
                showTransferError={showTransferError}
                confirmPhotos={confirmPhotos}
                onAcceptContent={acceptContent}
                onSetConfirmPhotos={setConfirmPhotos}
            />
            <Modal
                isOpen={denyApplicantModal}
                onAfterOpen={afterOpenModal}
                onRequestClose={closeModal}
                className={"invite-modal"}
                style={styles.modal}
            >
                <View style={{alignItems: 'center', backgroundColor: 'white', borderRadius: 10, padding: 20}}>
                    <Text style={[styles.sectionText, {margin: 10}]}>Deny {selectedCreator.first_name} {selectedCreator.last_name} from your campaign?</Text>
                    <View style={{width: '70%'}}>
                        <View style={{flexDirection: 'row', alignItems: 'center', justifyContent: 'center', width: '100%'}}>
                            <Button text="Cancel" onPress={closeModal} variant='secondary' style={{marginRight: 10, marginTop: 10}} />
                            <Button text={"Deny"} onPress={triggerCampaignDeny} style={{marginTop: 10}}/>
                        </View>
                    </View>
                </View>
            </Modal>
            <Toaster
                position="top-center"
                reverseOrder={false}
                gutter={8}
                containerClassName=""
                containerStyle={{}}
                toastOptions={{
                    // Define default options
                    className: '',
                    duration: 3000,
                    style: {
                        background: '#363636',
                        color: '#fff',
                    },

                    // Default options for specific types
                    success: {
                        duration: 2000,
                        theme: {
                            primary: 'green',
                            secondary: 'black',
                        },
                    },
                }}
            />
        </div>

    );
}

const styles = StyleSheet.create({
    creatorStatusContainer: {
        backgroundColor: 'white',
        borderRadius: 12,
        padding: 20,
        marginBottom: 16,
        marginLeft: '2.5%',
        marginRight: '2.5%',
        shadowColor: '#000',
        shadowOffset: { width: 0, height: 2 },
        shadowOpacity: 0.1,
        shadowRadius: 8,
        elevation: 3,
        borderWidth: 1,
        borderColor: '#e5e7eb',
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'space-between',
    },
    boldText: {
        fontWeight: 700,
        fontFamily: "'lato', sans-serif",
        fontSize: 16,
        marginRight: 5,
    },
    text: {
        fontFamily: "'lato', sans-serif",
        fontSize: 16,
        marginRight: 5,
    },
    creatorStatusSelection: {
        flexDirection: 'row',
        alignItems: 'center',
        padding: 10,
        borderRadius: 5,
    },
    creatorStatusSelectionHighlighted: {
        flexDirection: 'row',
        alignItems: 'center',
        backgroundColor: '#d1e6ff',
        color: 'white',
        padding: 10,
        borderRadius: 5,
    },
    modal: {
        overlay: {
            display: 'flex',
            flex: 1,
            justifyContent: 'center',
            alignContent: 'center',
            backgroundColor: 'rgba(57, 109, 224, .5)'
        },
        content: {
            margin: '20%',
            inset: 0,
            background: 'none',
            flex: 1,
            border: 'none',
            alignSelf: 'center',
            alignContent: 'center',
            outline: 'none',
        }
    },
    sectionText: {
        fontFamily: "'forma-djr-display', sans-serif",
        fontSize: 30,
        fontWeight: 'bold',
        color: '#396de0',
    },
    greyInput: {
        color: '#737373',
        backgroundColor: '#EFEFEF',
        border: 'none',
        borderRadius: 5,
        width: '100%',
        paddingTop: 10,
        paddingBottom: 10,
        paddingLeft: 10,
    },
    messageView: {
        height: 600,
    },
    archivedView: {
        backgroundColor: 'white',
        borderRadius: 12,
        padding: 20,
        marginBottom: 16,
        marginLeft: '2.5%',
        marginRight: '2.5%',
        shadowColor: '#000',
        shadowOffset: { width: 0, height: 2 },
        shadowOpacity: 0.1,
        shadowRadius: 8,
        elevation: 3,
        borderWidth: 1,
        borderColor: '#e5e7eb',
    },
    arrowIcon: {
        height: 20,
        width: 20,
    },
    rotatedArrowIcon: {
        height: 20,
        width: 20,
        transform: [{rotate: '180deg'}],
    },
    redText: {
        color: '#e03939',
        fontFamily: "'lato', sans-serif",
        fontWeight: 'bold',
    },
    checkboxContainer: {
        flexDirection: 'row',
        alignItems: 'center',
        marginTop: 15,
        marginBottom: 10,
    },
    checkboxLabel: {
        marginLeft: 10,
        fontFamily: "'lato', sans-serif",
        fontSize: 16,
        color: '#396de0',
    },
});

export default Campaign
